"use client";
import React from "react";
import Expert from "../Images/Experties.png";
import Expert1 from "../Images/Person.png";
import Expert2 from "../Images/Techonology.png";
import Expert3 from "../Images/Compliance Assurance.png";
import Expert4 from "../Images/images__8_-removebg-preview.png";
import Expert5 from "../Images/Risk.png";
function WhyChooseUs() {
  return (
    <section className="why-section">
      <div className="container">
        {/* HEADING */}
        <h2 className="main-title">
          <span>  Why Choose ComplianceKare</span>
        </h2>
        {/* CARDS */}
        <div className="row g-4">
          <div className="col-md-4 col-sm-6">
            <div className="why-card">
              <img src={Expert} />
              <h4>Expertise</h4>
              <p>
                Our team comprises seasoned tax professionals certified and knowledgeable Experts with in-depth knowledge of tax laws, regulations, and a proven track record of delivering accurate and reliable financial services.
              </p>
            </div>
          </div>

          <div className="col-md-4 col-sm-6">
            <div className="why-card">
              <img src={Expert1} />
              <h4>Personalized Approach</h4>
              <p>
                We understand that every business is unique. That's why we take the time to understand your specific requirements and craft customized solutions to address your financial challenges.
              </p>
            </div>
          </div>

          <div className="col-md-4 col-sm-6">
            <div className="why-card">
              <img src={Expert2} />
              <h4>Technology Integration</h4>
              <p>
                Embracing cutting-edge accounting technologies, we ensure efficiency, accuracy, and security in handling your financial data.
              </p>
            </div>
          </div>

          <div className="col-md-4 col-sm-6">
            <div className="why-card">
              <img src={Expert3} />
              <h4>Compliance Assurance</h4>
              <p>
                Stay ahead of regulatory changes and tax obligations with our expert guidance, ensuring that your business remains in full compliance with applicable laws.
              </p>
            </div>
          </div>

          <div className="col-md-4 col-sm-6">
            <div className="why-card">
              <img src={Expert4} />
              <h4>Strategic Planning</h4>
              <p>
                Beyond compliance, we focus on strategic tax planning to help you make informed financial decisions and optimize your tax position.
              </p>
            </div>
          </div>

          <div className="col-md-4 col-sm-6">
            <div className="why-card">
              <img src={Expert5} />
              <h4>Risk Mitigation</h4>
              <p>
                We focus on proactive risk management, helping businesses identify and address potential compliance issues before they escalate.
              </p>
            </div>
          </div>

        </div>

      </div>

      <style jsx>{`
        .why-section {
          padding: 80px 0;
          background: linear-gradient(135deg, #f4f8ff, #ffffff);
        }

        .main-title {
          font-size: 34px;
          font-weight: 800;
        }

        .main-title span {
          color: #115886;
        }

        /* Card */
        .why-card {
          background: #fff;
          padding: 25px;
          border-radius: 18px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.05);
          text-align: center;
          transition: 0.3s;
          height: 100%;
        }

        .why-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 20px 40px rgba(0,0,0,0.1);
        }

        .why-card img {
          width: 60px;
          margin-bottom: 15px;
        }

        .why-card h4 {
          color: #115886;
          font-weight: 700;
          margin-bottom: 10px;
        }

        .why-card p {
          color: #6b7280;
          font-size: 14px;
          margin-bottom: 0;
          line-height: 1.6;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .main-title {
            font-size: 24px;
          }
        }
      `}</style>
    </section>
  );
}

export default WhyChooseUs;